import React, { useRef, useState, useEffect } from 'react';
import { motion, useInView } from 'motion/react';
import './Contact.css';

export default function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });
  const [copied, setCopied] = useState(false);
  const [nearLink, setNearLink] = useState(null);
  const emailRef = useRef(null);
  const linkedinRef = useRef(null);
  const topmateRef = useRef(null);

  const copyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText('raunakagarwal.id@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 5000);
  };

  useEffect(() => {
    const refs = { email: emailRef, linkedin: linkedinRef, topmate: topmateRef };
    const handleMouseMove = (e) => {
      let found = null;
      for (const [name, r] of Object.entries(refs)) {
        if (!r.current) continue;
        const rect = r.current.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dist = Math.sqrt((e.clientX - cx) ** 2 + (e.clientY - cy) ** 2);
        if (dist < 70) { found = name; break; }
      }
      setNearLink(found);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <footer className="footer" ref={ref}>
      <div className="footer-container">
        <motion.div
          className="footer-wrapper"
          initial={{ y: 40, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="footer-block" data-outline>
            <h2 className="footer-heading">Lets work together!</h2>
            <p className="footer-text">
              Just send an email. I'd love to join your design team for the next project to build great products together!
            </p>
          </div>
          <div className="footer-links" data-outline>
            <a href="#" onClick={copyEmail} className={`footer-link ${nearLink === 'email' ? 'footer-link-near' : ''}`} ref={emailRef}>
              <div className="footer-link-inner">
                <div className="footer-icon">
                  <svg className="footer-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="M22 4L12 13 2 4" />
                  </svg>
                </div>
                <span className="footer-link-text">Email me</span>
              </div>
            </a>
            <a href="https://www.linkedin.com/in/raunakagarwal-fc/" target="_blank" rel="noreferrer" className={`footer-link ${nearLink === 'linkedin' ? 'footer-link-near' : ''}`} ref={linkedinRef}>
              <div className="footer-link-inner">
                <div className="footer-icon">
                  <svg className="footer-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
                    <rect x="2" y="9" width="4" height="12" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </div>
                <span className="footer-link-text">LinkedIn</span>
              </div>
            </a>
            <a href="https://topmate.io/raunak_agarwal_07" target="_blank" rel="noreferrer" className={`footer-link ${nearLink === 'topmate' ? 'footer-link-near' : ''}`} ref={topmateRef}>
              <div className="footer-link-inner">
                <div className="footer-icon">
                  <svg className="footer-icon-svg" width="20" height="20" viewBox="-3 -3 53 52" fill="none" stroke="currentColor" strokeWidth="3">
                    <circle r="22.5" transform="matrix(1 0 0 -1 23.6152 23)" fill="none"/>
                    <path d="M33.0038 29.6411C31.5707 31.6672 29.5206 33.1752 27.1598 33.9401C24.7989 34.705 22.254 34.6857 19.905 33.8851C17.5561 33.0844 15.5291 31.5454 14.1269 29.4978C12.7247 27.4503 12.0225 25.0041 12.1251 22.5246C12.2277 20.045 13.1296 17.6652 14.6962 15.7405C16.2627 13.8158 18.4099 12.4495 20.817 11.8456C23.224 11.2418 25.7619 11.4328 28.0515 12.3901C30.341 13.3474 32.2595 15.0197 33.5204 17.1572L23.6152 23L33.0038 29.6411Z" fill="none"/>
                  </svg>
                </div>
                <span className="footer-link-text">Book a call</span>
              </div>
            </a>
          </div>
          {copied && (
            <div className="footer-copied"><span className="prompt">➜ </span><span className="email-highlight">raunakagarwal.id@gmail.com</span> copied to clipboard</div>
          )}
        </motion.div>
      </div>
    </footer>
  );
}
